{
  "Ask me anything...": "Ask me anything...",
  "Beta": "Beta",
  "Close Chatbot": "Close Chatbot",
  "Hi, I'm your AI guide to all things Weave!": "Hi, I'm your AI guide to all things Weave!",
  "I'm here to help you get started.": "I'm here to help you get started.",
  "Loading...": "Loading...",
  "Minimize": "Minimize",
  "Minimize AI Chat": "Minimize AI Chat",
  "Open Chatbot": "Open Chatbot",
  "Pop Out": "Pop Out",
  "Send": "Send",
  "Something went wrong. Please try again.": "Something went wrong. Please try again.",
  "Thank you for your feedback!": "Thank you for your feedback!",
  "Weave AI": "Weave AI"
}
